import { Column } from "primereact/column";
import { DataTable, DataTableProps } from "primereact/datatable";
import {
  ContactGroup,
  ContactType,
} from "../../api/firebase/types/contact.types";
import { ContactOption } from "../../api/firebase/types/scenario.types";
import { ContactOptionColumnTemplate } from "./templates/ContactOptionColumnTemplate";

type ContactOptionTableProps = Omit<DataTableProps, "value" | "onChange"> & {
  contactSettings: Map<ContactOption, string[]>;
  onChange: (contactSettings: Map<ContactOption, string[]>) => void;
  value: ContactType[] | ContactGroup[];
};

const ContactOptionTable: React.FC<ContactOptionTableProps> = ({
  contactSettings,
  onChange,
  ...props
}) => {
  return (
    <DataTable
      {...props}
      className="p-datatable-striped p-m-2"
      size="small"
      scrollable
      scrollHeight="400px"
      responsiveLayout="scroll"
    >
      {props.children}
      <Column
        header="Anruf"
        className="p-jc-center"
        body={(contactOrGroup) =>
          ContactOptionColumnTemplate(
            contactOrGroup,
            ContactOption.CALL,
            contactSettings,
            onChange
          )
        }
      />
      <Column
        header="SMS"
        className="p-jc-center"
        body={(contactOrGroup) =>
          ContactOptionColumnTemplate(
            contactOrGroup,
            ContactOption.MESSAGE,
            contactSettings,
            onChange
          )
        }
      />
      <Column
        header="Email"
        className="p-jc-center"
        body={(contactOrGroup) =>
          ContactOptionColumnTemplate(
            contactOrGroup,
            ContactOption.EMAIL,
            contactSettings,
            onChange
          )
        }
      />
    </DataTable>
  );
};

export default ContactOptionTable;
